import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { currentEnv, isMaintenanceTime } from "./config/config";
import Outage from "./revampPages/Outage";
import * as Sentry from "@sentry/react";
import { SequenceNumberProvider } from "./contexts/SequenceNumberContext";
import { Buffer } from 'buffer';
import process from 'process';

window.Buffer = Buffer;
window.process = process;

Sentry.init({
    dsn: "https://e486677cbc950ba4404332783c5dbe49@o4508326426181632.ingest.de.sentry.io/4508496551411792",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    ignoreErrors: [
        // Common browser extension errors
        /chrome-extension:/,
        /ExtensionsBundleLoader/,
        /chrome-extension:\/\//,
        /extensions::/,
        // Specific library errors (e.g., Axios)
        /Network Error/,
        /ETIMEDOUT/,
        /ECONNABORTED/,
        / AxiosError /,
        /fetch failed/,
        // Optional: Broad regex for node_modules (less reliable)
        /node_modules/,
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: currentEnv,
    // This is suposed to ignore node_modules
    beforeSend(event) {
        return isNodeModulesError(event) ? null : event;
    }
});

function isNodeModulesError(event) {
    if (!event.exception?.values) return false;

    for (const exception of event.exception.values) {
        if (!exception.stacktrace?.frames?.length) continue;
        const frames = exception.stacktrace?.frames || [];
        const hasNodeModules = frames.some((frame) => {
            const filename = frame.filename || "";
            const absPath = frame.abs_path || "";
            return (
                // Handle Webpack-generated paths (common in CRA)
                filename.includes("node_modules") ||
                absPath.includes("node_modules") ||
                /webpack:\/\/\/\.\/node_modules\//.test(absPath) ||
                absPath.includes("webpack:///./node_modules/") || // Webpack client-side
                absPath.includes("~") // Some setups alias node_modules to "~"
            );
        });

        if (hasNodeModules) return true;
    }
    return false;
}

ReactDOM.render(
    <Provider store={store}>
        <Sentry.ErrorBoundary>
            <SequenceNumberProvider>
                {isMaintenanceTime ?
                    <Outage />
                    :
                    <App />
                }
            </SequenceNumberProvider>
        </Sentry.ErrorBoundary>
    </Provider>,
    document.getElementById("root")
);
serviceWorker.unregister();
reportWebVitals();
